"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.show = show;
exports.Faq = exports.default = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _reactDom = babelHelpers.interopRequireDefault(require("react-dom"));

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _base = require("modals/base");

var _promisePolyfill = babelHelpers.interopRequireDefault(require("promise-polyfill"));

var _decorators = require("decorators");

var _fetch = babelHelpers.interopRequireDefault(require("fetch"));

var _userProfile = require("user-profile");

var _noty = require("noty");

var _animationHelper = require("animation-helper");

var _class, _temp, _class3;

var NoOp = function NoOp() {};

var FaqModal =
/*#__PURE__*/
function (_ReactModal) {
  babelHelpers.inherits(FaqModal, _ReactModal);

  function FaqModal() {
    var _this;

    babelHelpers.classCallCheck(this, FaqModal);
    _this = babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(FaqModal).call(this));
    _this.removeOnHide = true;
    _this.classList = _this.classList.concat('faq-modal');

    _this.setComponent(_react.default.createElement(Faq, {
      modal: babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this))
    }));

    return _this;
  }

  return FaqModal;
}(_base.ReactModal);

exports.default = FaqModal;
var Faq = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(Faq, _Component);

  function Faq() {
    var _babelHelpers$getProt;

    var _this2;

    babelHelpers.classCallCheck(this, Faq);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this2 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(Faq)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    _this2.state = {
      submissionComplete: false,
      submitting: false,
      question: ""
    };
    return _this2;
  }

  babelHelpers.createClass(Faq, [{
    key: "setValue",
    value: function setValue(questionId, answer) {
      this.setState(babelHelpers.defineProperty({}, questionId, answer));
    }
  }, {
    key: "canSubmit",
    value: function canSubmit() {
      if (this.state.submitting) return false;
      if (!this.state.question) return false;
      return true;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;

      this.props.modal.element.firstElementChild.addEventListener('scroll', function () {
        _this3.tempScrollPosition = _this3.props.modal.element.firstElementChild.scrollTop;
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.props.modal.element.firstElementChild.scrollTop = this.tempScrollPosition;
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.submissionComplete) {
        return _react.default.createElement("div", {
          className: "faq-body"
        }, _react.default.createElement(FaqItem, {
          type: "icon",
          text: "check"
        }), _react.default.createElement(FaqItem, {
          type: "header",
          text: "Thank You"
        }), _react.default.createElement(FaqItem, {
          type: "displayedText",
          text: "Thank you for your question! Please give our advisors a few days to answer. You will receive a notification when it gets a response."
        }), _react.default.createElement("div", {
          className: "form-submit"
        }, _react.default.createElement("button", {
          className: "btn btn-primary",
          "data-dismiss": "modal"
        }, "Close")));
      }

      return _react.default.createElement("form", {
        className: "faq-body",
        onSubmit: this.submitFaq
      }, _react.default.createElement(FaqItem, {
        type: "header",
        text: "Ask Sundance"
      }), _react.default.createElement(FaqItem, {
        type: "displayedText",
        text: "There is no one way to be a great storyteller and many ways to shape a career. This is your chance to ask our Sundance advisors about their creative process, their experiences and the paths they have taken in starting up and sustaining their careers."
      }), this.state.error && _react.default.createElement("div", {
        className: "alert alert-danger"
      }, this.state.error === true ? 'An error occurred submitting your question. Try again later.' : this.state.error), _react.default.createElement("br", null), _react.default.createElement("br", null), _react.default.createElement(FaqItem, {
        type: "textField",
        setValue: this.setValue,
        id: "question",
        value: this.state.question || "",
        text: "",
        disabled: this.state.submitting
      }), _react.default.createElement("div", {
        className: "form-submit"
      }, _react.default.createElement("button", {
        className: "btn btn-primary",
        disabled: !this.canSubmit()
      }, "Submit Your Question")));
    }
  }, {
    key: "submitFaq",
    value: function submitFaq(event) {
      var _this4 = this;

      event.preventDefault();

      if (this.state.submitting) {
        return;
      }

      this.setState({
        error: false,
        submitting: true
      }, function () {
        (0, _fetch.default)("data/faq/submit", {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            question: _this4.state.question
          })
        }).then(function (result) {
          if (result.ok) {
            return result.status == 204 ? true : result.json();
          }

          return result.json().then(function (value) {
            throw value;
          });
        }).then(function () {
          _this4.setState({
            submissionComplete: true
          }); // this.props.modal.hide();
          // showNotificationText('Your question has been posted.')

        }).catch(function (e) {
          _this4.setState({
            error: true,
            submitting: false
          });
        });
      });
    }
  }]);
  return Faq;
}(_react.Component), _temp), (babelHelpers.applyDecoratedDescriptor(_class.prototype, "setValue", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "setValue"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "submitFaq", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "submitFaq"), _class.prototype)), _class);
exports.Faq = Faq;

var FaqItem = function FaqItem(props) {
  var Type = Faq[props.type];
  return _react.default.createElement(Type, props);
};

Faq.header = function (_ref) {
  var text = _ref.text;
  return _react.default.createElement("h1", null, text);
};

Faq.icon = function (_ref2) {
  var text = _ref2.text;
  return _react.default.createElement("h1", null, _react.default.createElement("span", {
    className: "material-icons",
    "data-icon": text
  }));
};

Faq.displayedText = function (_ref3) {
  var text = _ref3.text;
  return _react.default.createElement("p", null, text);
};

Faq.textField = (_class3 =
/*#__PURE__*/
function (_Component2) {
  babelHelpers.inherits(_class3, _Component2);

  function _class3() {
    babelHelpers.classCallCheck(this, _class3);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(_class3).apply(this, arguments));
  }

  babelHelpers.createClass(_class3, [{
    key: "setValue",
    value: function setValue(event) {
      this.props.setValue(this.props.id, event.target.value);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.value != this.props.value && this.fakeElement && this.commentField) {
        this.updateSize();
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateSize();
    }
  }, {
    key: "gotCommentField",
    value: function gotCommentField(node) {
      this.commentField = node;
    }
  }, {
    key: "gotFakeElement",
    value: function gotFakeElement(node) {
      this.fakeElement = node;
    }
  }, {
    key: "updateSize",
    value: function updateSize() {
      var _this5 = this;

      if (this.fakeElement && this.commentField) {
        var v = this.props.value || "Ask your question here...";
        var nl = this.fakeElement.childNodes;
        var cStyle = window.getComputedStyle(this.commentField);
        ['boxSizing', 'paddingTop', 'paddingBottom', 'paddingLeft', 'paddingRight', 'borderTopWidth', 'borderLeftWidth', 'borderRightWidth', 'borderBottomWidth', 'whiteSpace', 'fontFamily', 'fontStyle', 'fontSize', 'fontWeight', 'lineHeight'].forEach(function (p) {
          return _this5.fakeElement.style[p] = cStyle[p];
        });
        this.fakeElement.style.position = 'fixed';
        this.fakeElement.style.right = '150%';
        v = v.split('\n');

        for (var i = 0; i < v.length; i++) {
          if (!nl[i]) this.fakeElement.appendChild(document.createElement('div'));
          nl[i].textContent = v[i] || '\xa0';
        }

        while (nl.length > v.length) {
          this.fakeElement.removeChild(nl[nl.length - 1]);
        }

        var w,
            tgtH,
            rowCount = this.commentFieldMinLines;

        do {
          w = this.commentField.clientWidth;
          console.log(this.fakeElement.style.width = this.fakeElement.style.boxSizing == 'border-box' ? "".concat(w, "px") : "calc(".concat(w, "px - ").concat(cStyle.paddingLeft, " - ").concat(cStyle.paddingRight, " - ").concat(cStyle.borderLeftWidth, " - ").concat(cStyle.borderRightWidth, ")"));
          tgtH = this.fakeElement.offsetHeight;
          console.log(this.commentField.style.height = this.fakeElement.style.boxSizing == 'border-box' ? "calc(".concat(tgtH, "px + 2px)") : "calc(".concat(tgtH, "px - ").concat(cStyle.paddingTop, " - ").concat(cStyle.paddingBottom, " - ").concat(cStyle.borderTopWidth, " - ").concat(cStyle.borderBottomWidth, " + 2px)"));
        } while (w != this.commentField.clientWidth);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          id = _this$props.id,
          text = _this$props.text,
          required = _this$props.required,
          options = _this$props.options,
          disabled = _this$props.disabled;
      return _react.default.createElement("div", {
        className: "form-group"
      }, _react.default.createElement("label", {
        htmlFor: "question_".concat(id)
      }, text, required && " ", required && _react.default.createElement("span", {
        className: "required"
      }, "*")), _react.default.createElement("textarea", {
        ref: this.gotCommentField,
        className: "form-control",
        name: id,
        id: "question_".concat(id),
        rows: "3",
        value: this.props.value,
        onChange: this.setValue,
        disabled: disabled,
        placeholder: "Ask your question here..."
      }), _react.default.createElement("div", {
        className: _classList.default.join('fake-textarea', this.props.value ? '' : 'fake-textarea-placeholder'),
        ref: this.gotFakeElement
      }));
    }
  }]);
  return _class3;
}(_react.Component), (babelHelpers.applyDecoratedDescriptor(_class3.prototype, "setValue", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "setValue"), _class3.prototype), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "gotCommentField", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "gotCommentField"), _class3.prototype), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "gotFakeElement", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "gotFakeElement"), _class3.prototype)), _class3);

function show() {
  new FaqModal().show();
}